import * as React from 'react'
import * as classNames from 'classnames'
import { Site } from '@envato/foundation-types'

import * as styles from './verticalDivider.module.css'

interface IProps {
  label: string
  currentSite: Site
  className?: string
}

const VerticalDivider = ({ label, currentSite, className = '' }: IProps) => {
  const labelClassName = classNames(styles.label, {
    [styles.siteThemeforest]: currentSite === Site.themeforest,
    [styles.siteVideohive]: currentSite === Site.videohive,
    [styles.siteAudiojungle]: currentSite === Site.audiojungle,
    [styles.siteCodecanyon]: currentSite === Site.codecanyon,
    [styles.siteGraphicriver]: currentSite === Site.graphicriver,
    [styles.sitePhotodune]: currentSite === Site.photodune,
    [styles.site3docean]: currentSite === Site.threedocean
  })
  return (
    <div className={`${styles.root} ${className}`}>
      <div className={styles.line} />
      <div className={labelClassName}>{label}</div>
      <div className={styles.line} />
    </div>
  )
}

export default VerticalDivider
